<template>
	<div class="EmploymentDetails" >
		<div class="row">
			<div class="col-xs-12 col-md-6 q-pa-sm" style="padding: 8px !important;">
				<div rounded class="">
					<!-- <q-field  :label='$t("Employment-Detail.title")'  orientation="vertical" readonly></q-field> -->
					<div class="row">
						<div class="col-12">
							<b>{{$t("Employment-Detail.title")}}</b>
						</div>
						<div class="col-12">
							{{$t("Employment-Detail.empstatus")}}
							<q-select
								outlined 
								lazy-rulesss :rules="[val => !!val ||  '' + $t('common.fieldRequired') +' ']"
								filter
								color="primary"
								behavior="menu"
								v-model="StoreStateED.EmploymentStatus"
								:options="StoreStateLookup.EmploymentStatus_LK"
								:readonly="$route.name==='Application Details'"
							/>
						</div>
					</div>
					<div class="row" v-if="StoreStateED.EmploymentStatus==='Self employed' || StoreStateED.EmploymentStatus==='Employed'||StoreStateED.EmploymentStatus==='Bekerja' ||StoreStateED.EmploymentStatus==='Bekerja Sendiri' ||StoreStateED.EmploymentStatus.value==='1' || StoreStateED.EmploymentStatus.value==='2'">
						<div class="col-12">
							{{$t("Employment-Detail.businessnature")}}
							<q-select
								outlined 
								lazy-rulesss :rules="[val => !!val ||  '' + $t('common.fieldRequired') +' ']"
								filter
								color="primary"
								behavior="menu"
								v-model="StoreStateED.BusinessNature"
								:options="StoreStateLookup.NatureofBusiness_LK"
								:readonly="$route.name==='Application Details'"
							/>
						</div>
					</div>

					<!-- Xp said, if 'unemployed' selected, need to specify reason -->

					<div class="row" v-if="(StoreStateED.EmploymentStatus==='Self employed' || StoreStateED.EmploymentStatus==='Employed'||StoreStateED.EmploymentStatus==='Bekerja' ||StoreStateED.EmploymentStatus==='Bekerja Sendiri' || StoreStateED.EmploymentStatus.value==='1' || StoreStateED.EmploymentStatus.value==='2') && (StoreStateED.BusinessNature.value==='A18'||StoreStateED.BusinessNature2==='A18')">
						<div class="col-12">
							{{$t("Employment-Detail.a18")}}
							<q-input outlined lazy-rulesss :rules="[val => !!val ||  '' + $t('common.fieldRequired') +' ']" v-model="StoreStateED.BusinessNatureOther" 
								 :readonly="$route.name==='Application Details'"/>
						</div>
					</div>
					<div class="row" v-if="StoreStateED.EmploymentStatus==='Employed'||StoreStateED.EmploymentStatus==='Bekerja' ||StoreStateED.EmploymentStatus.value==='2'">
						<div class="col-12">
							{{$t("Employment-Detail.designation")}}
							<q-input outlined lazy-rulesss :rules="[val => !!val ||  '' + $t('common.fieldRequired') +' ']" v-model="StoreStateED.Designation" :readonly="$route.name==='Application Details'"/>
						</div>
					</div>
					
				</div>
					</div>
					
					<div class="col-xs-12 col-md-6 q-pa-sm" style="padding: 8px !important;">
						<div v-if="StoreStateED.EmploymentStatus==='Employed'||StoreStateED.EmploymentStatus==='Bekerja' ||StoreStateED.EmploymentStatus.value==='2'" 
						rounded class="">
							<!-- <q-field  :label='$t("Employment-Detail.employerdetals")'  readonly orientation="vertical"></q-field> -->
							<div class="row" v-if="StoreStateED.EmploymentStatus==='Employed'||StoreStateED.EmploymentStatus==='Bekerja'||StoreStateED.EmploymentStatus.value==='2'">
								<div class="col-12">
									<b>{{$t("Employment-Detail.employerdetails")}}</b>
								</div>
								<div class="col-12">
									{{$t("Employment-Detail.employername")}}
									<q-input outlined lazy-rulesss :rules="[val => !!val ||  '' + $t('common.fieldRequired') +' ']" v-model="StoreStateED.EmployerName" :readonly="$route.name==='Application Details'"/>
								</div>
							</div>
							<div class="row" v-if="StoreStateED.EmploymentStatus==='Employed'||StoreStateED.EmploymentStatus==='Bekerja' ||StoreStateED.EmploymentStatus.value==='2'">
								<div class="col-12">
									{{$t("Employment-Detail.employeradd")}}
									<q-input  type="textarea" outlined lazy-rulesss :rules="[val => !!val ||  '' + $t('common.fieldRequired') +' ']" v-model="StoreStateED.EmployerAddress.Address1" :readonly="$route.name==='Application Details'"/>
								</div>
							</div>	
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="stylus" scoped>
.row > div {
  padding: 10px 15px
}
</style>
<style >
.q-field__messages {
    text-align: left !important;
}
</style>

<script>

import LookUp from '../assets/json/FieldsLookUp.json'
import store from '../store';
export default {
  name: 'EmploymentDetails',
  props: {
  },
  data () {
    return {
		StoreStateED : store.state.ED,
		StoreStateForm : store.state.FORM,
		StoreStateLookup : store.state.Lookup,
		Country_LK : this.parseCountries(),
		City_LK : this.parseCities(),
		State_LK : this.parseStates(),
		BusinessNature_LK : LookUp.BusinessNature,
		EmploymentStatus_LK : LookUp.EmploymentStatus,
			DocType : ''
    }
	},
	mounted () {
	},
	methods: {
	add: function (file) {
		let uploader = this.$refs.uploader
		uploader.file = uploader.files.concat(file)
		uploader.upload()
	},
    search (terms, done) {
      setTimeout(() => {
        done(filter(terms, {field: 'value', list: this.City_LK}))
      }, 1000)
    }/* ,
    selected (item) {
      this.$q.notify(`Selected suggestion "${item.label}"`)
    } */
    ,parseCountries(){
      return LookUp.Countries.map(country => {
        return {
          label: country,
          value: country
        }
      })
    }
    ,parseCities () {
      return LookUp.Cities.map(city => {
        return {
          label: city,
          value: city
        }
      })
    }
    ,parseStates () {
      return LookUp.States.map(state => {
        return {
          label: state,
          value: state
        }
      })
    },
		uploadFile (file, updateProgress) {
        var blobUri = 'https://' + 'nadiablob' + '.blob.core.windows.net';
        var blobService = AzureStorage.Blob.createBlobServiceWithSas(blobUri, '?sv=2018-03-28&ss=bfqt&srt=sco&sp=rwdlacup&se=2023-05-07T08:43:39Z&st=2019-05-07T00:43:39Z&spr=https&sig=IkvEUVOmAdLCOyJpUKeQBjpWo7cw7hqVll%2FZQeokC0Y%3D');

        blobService.createContainerIfNotExists('temp-onboarding',  (error, container) => {
            if (!error) {
               // Container created or exists, and is public
               //console.log(container.name);

                blobService.createBlockBlobFromBrowserFile('temp-onboarding', 
                    this.StoreStateForm.ApplicationId + '/' + this.DocType + '/' + file.name, 
                    file, 
                    (error, result) => {
                        if(error) {
                            // Handle blob error
                        } else {
							//console.log( file.name + ' is upload successful');
							this.StoreStateED.BusinessCardAttachment = file.name;
						}
						this.$store.dispatch("PostApp_All", { Status: "Pending Agent", ApplicationId: this.StoreStateForm.ApplicationId });
                    });
            }
		});
		},
		ChangeDocType(value){
			this.DocType = value;
		},
		ViewFile(){
			var FileName = this.StoreStateED.BusinessCardAttachment;
			var location = 'https://nadiablob.blob.core.windows.net';
			var container = 'temp-onboarding';
			var filepath = this.StoreStateForm.ApplicationId + '/' + 'Business Card' + '/' + FileName;
			var Uri = '?sv=2018-03-28&ss=bfqt&srt=sco&sp=rwdlacup&se=2023-05-07T08:43:39Z&st=2019-05-07T00:43:39Z&spr=https&sig=IkvEUVOmAdLCOyJpUKeQBjpWo7cw7hqVll%2FZQeokC0Y%3D';
			window.open(location + '/' + container + '/' + filepath + Uri);
		},
		DeleteFile(){
			var blobUri = 'https://' + 'nadiablob' + '.blob.core.windows.net';
      		var blobService = AzureStorage.Blob.createBlobServiceWithSas(blobUri, '?sv=2018-03-28&ss=bfqt&srt=sco&sp=rwdlacup&se=2023-05-07T08:43:39Z&st=2019-05-07T00:43:39Z&spr=https&sig=IkvEUVOmAdLCOyJpUKeQBjpWo7cw7hqVll%2FZQeokC0Y%3D');
			var FileName = this.StoreStateED.BusinessCardAttachment;
			var filepath = this.StoreStateForm.ApplicationId + '/' + 'Business Card' + '/' + FileName;
			var blobName = filepath;
			var container = 'temp-onboarding';
			blobService.deleteBlobIfExists(container, blobName, (error, result) => {
					if (error) {
						// Handle delete blob error
					} else {
						this.StoreStateED.BusinessCardAttachment = '';
						this.$store.dispatch("PostApp_All", { Status: "Pending Agent", ApplicationId: this.StoreStateForm.ApplicationId });
						//console.log('Blob deleted successfully');
					}
			});
		},
		SaveChangesED(){
				this.$store.dispatch('PostApp_ED');
		},
		PopulateEmployerAddressFromPostcode(){
			var postcode = this.StoreStateED.EmployerAddress.Postcode;
			this.$store.dispatch('SetEmployerAddressByPostcode', postcode);
		},
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>